
import React from 'react';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { sanitizeText } from '@/lib/security/input-validation';

interface SecureInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onSecureChange?: (value: string) => void;
}

export const SecureInput = React.forwardRef<HTMLInputElement, SecureInputProps>(({ 
  onSecureChange, 
  onChange,
  ...props 
}, ref) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Don't sanitize during typing - only call onSecureChange with sanitized value
    const sanitized = sanitizeText(e.target.value);
    onChange?.(e);
    onSecureChange?.(sanitized);
  };

  return <Input {...props} ref={ref} onChange={handleChange} />;
});

SecureInput.displayName = "SecureInput";

interface SecureTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  onSecureChange?: (value: string) => void;
}

export const SecureTextarea = React.forwardRef<HTMLTextAreaElement, SecureTextareaProps>(({ 
  onSecureChange, 
  onChange,
  ...props 
}, ref) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    // Don't sanitize during typing - only call onSecureChange with sanitized value
    const sanitized = sanitizeText(e.target.value);
    onChange?.(e);
    onSecureChange?.(sanitized);
  };

  return <Textarea {...props} ref={ref} onChange={handleChange} />;
});

SecureTextarea.displayName = "SecureTextarea";
